import { apiClient } from "../config";

async function getDashboardConfiguration() {
  const res = await apiClient.get(`/admin/dashboard/configuration`);
  return res.data;
}

export default getDashboardConfiguration;
